"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    border: none;\n    font-size: 1em;\n    text-align: center;\n    transition: background-color 0.25s ease;\n    min-height: ", "em;\n    font-weight: ", ";\n    text-transform: ", ";\n    border-radius: ", ";\n    margin-bottom: ", "em;\n\n    // hollow button styles\n    ", ";\n\n    //  disabled button styles\n    ", ";\n\n    // active style\n    ", ";\n\n    // expanded\n    ", ";\n"], ["\n    border: none;\n    font-size: 1em;\n    text-align: center;\n    transition: background-color 0.25s ease;\n    min-height: ", "em;\n    font-weight: ", ";\n    text-transform: ", ";\n    border-radius: ", ";\n    margin-bottom: ", "em;\n\n    // hollow button styles\n    ", ";\n\n    //  disabled button styles\n    ", ";\n\n    // active style\n    ", ";\n\n    // expanded\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  background-color: ", ";\n              "], ["\n                  color: ", ";\n                  background-color: ", ";\n              "]),
    _templateObject3 = _taggedTemplateLiteral(["\n                  color: ", ";\n                  box-shadow: inset 0 0 0 ", "px\n                      ", ";\n                  background-color: transparent;\n              "], ["\n                  color: ", ";\n                  box-shadow: inset 0 0 0 ", "px\n                      ", ";\n                  background-color: transparent;\n              "]),
    _templateObject4 = _taggedTemplateLiteral(["\n                  opacity: 0.5;\n                  cursor: not-allowed;\n              "], ["\n                  opacity: 0.5;\n                  cursor: not-allowed;\n              "]),
    _templateObject5 = _taggedTemplateLiteral(["\n                  cursor: pointer;\n              "], ["\n                  cursor: pointer;\n              "]),
    _templateObject6 = _taggedTemplateLiteral(["\n            &:hover {\n                background-color: ", ";\n            }\n        "], ["\n            &:hover {\n                background-color: ", ";\n            }\n        "]),
    _templateObject7 = _taggedTemplateLiteral(["\n                  width: 100%;\n              "], ["\n                  width: 100%;\n              "]),
    _templateObject8 = _taggedTemplateLiteral(["\n                  padding-left: ", "em;\n                  padding-right: ", "em;\n              "], ["\n                  padding-left: ", "em;\n                  padding-right: ", "em;\n              "]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../functions");

var _theme = require("../theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function hoverColor(x) {
    var hsl = (0, _functions.hexToHSL)(x);
    hsl.l = hsl.l * 0.8;
    var hex = (0, _functions.HSLToHex)(hsl);
    return hex;
}

var Button = _styledComponents2.default.button(_templateObject, function (props) {
    return _theme.sizes[props.size];
}, function (props) {
    return props.theme.button.fontWeight;
}, function (props) {
    return props.theme.button.textTransform;
}, function (props) {
    return props.borderRadius != undefined ? props.borderRadius : props.theme.button.borderRadius + "em";
}, function (props) {
    return props.margin != undefined ? props.margin : _theme.spacing.margin;
}, function (props) {
    return !props.hollow ? (0, _styledComponents.css)(_templateObject2, function (props) {
        return (0, _functions.foregroundColor)(_theme.colors[props.color], 0.6, props.theme.lightColor, props.theme.darkColor);
    }, function (props) {
        return _theme.colors[props.color];
    }) : (0, _styledComponents.css)(_templateObject3, function (props) {
        return _theme.colors[props.color];
    }, function (props) {
        return props.borderWidth;
    }, function (props) {
        return _theme.colors[props.color];
    });
}, function (props) {
    return props.disabled ? (0, _styledComponents.css)(_templateObject4) : (0, _styledComponents.css)(_templateObject5);
}, function (props) {
    return !props.hollow && !props.disabled && (0, _styledComponents.css)(_templateObject6, function (props) {
        return hoverColor(_theme.colors[props.color]);
    });
}, function (props) {
    return props.expanded ? (0, _styledComponents.css)(_templateObject7) : (0, _styledComponents.css)(_templateObject8, function (props) {
        return props.padding != undefined ? props.padding : _theme.spacing.padding;
    }, function (props) {
        return props.padding != undefined ? props.padding : _theme.spacing.padding;
    });
});

Button.displayName = "Button";

Button.propTypes = {
    expanded: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    hollow: _propTypes2.default.bool,
    color: _propTypes2.default.string,
    margin: _propTypes2.default.number,
    padding: _propTypes2.default.number,
    size: _propTypes2.default.string,
    borderRadius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    borderWidth: _propTypes2.default.number
};

Button.defaultProps = {
    expanded: false,
    disabled: false,
    hollow: false,
    color: Object.keys(_theme.colors)[0],
    size: Object.keys(_theme.sizes)[0],
    borderWidth: 1
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/button.js
// module id = 143
// module chunks = 95715928098905 168707334958949